import { Link } from "react-router-dom";
import {
  FiInstagram,
  FiPhone,
  FiMapPin,
  FiShoppingBag,
  FiShield,
  FiMessageCircle
} from "react-icons/fi";

const supportPhone = "09176427900";

const Footer = () => {
  return (
    <footer className="site-footer jooti-footer">
      <div className="site-container">
        <div className="jooti-footer-grid">
          <section className="jooti-footer-brand">
            <h3>جوتی</h3>
            <p>فروشگاه کفش و صندل زنانه با انتخاب‌های کاربردی، خرید ساده و پشتیبانی پاسخگو.</p>

            <div className="jooti-footer-badges">
              <span><FiShoppingBag /> خرید سریع</span>
              <span><FiShield /> تعویض تا ۴۸ ساعت</span>
            </div>

            <div className="jooti-footer-trust">
              <a referrerPolicy="origin" target="_blank" rel="noreferrer" href="https://trustseal.enamad.ir/?id=731535&Code=glKObwd3ytfgICuyc82cqq39xYIEmoSJ">
                <img referrerPolicy="origin" src="https://trustseal.enamad.ir/logo.aspx?id=731535&Code=glKObwd3ytfgICuyc82cqq39xYIEmoSJ" alt="نماد اعتماد الکترونیکی" style={{ cursor: "pointer" }} code="glKObwd3ytfgICuyc82cqq39xYIEmoSJ" />
              </a>
            </div>
          </section>

          <nav className="jooti-footer-widget">
            <h4>کالکشن‌ها</h4>
            <Link to="/category/women-sandals">صندل زنانه</Link>
            <Link to="/category/women-formal-shoes">کفش مجلسی</Link>
            <Link to="/category/women-work-shoes">کفش پرسنلی</Link>
            <Link to="/category/women-sport-shoes">اسپورت</Link>
            <Link to="/products">همه محصولات</Link>
          </nav>

          <nav className="jooti-footer-widget">
            <h4>راهنمای خرید</h4>
            <Link to="/about">درباره ما</Link>
            <Link to="/contact">تماس با ما</Link>
            <Link to="/terms">قوانین و مقررات</Link>
            <Link to="/shipping">رویه ارسال</Link>
            <Link to="/returns">تعویض و مرجوعی</Link>
          </nav>

          <section className="jooti-footer-widget jooti-footer-contact">
            <h4>ارتباط</h4>

            <a href={`tel:${supportPhone}`} className="jooti-footer-phone">
              <FiPhone />
              <span>{supportPhone}</span>
            </a>

            <div className="jooti-footer-channels">
              <span><FiMessageCircle /> کانال ما در پیام‌رسان‌های داخلی</span>
              <div>
                <a href="https://ble.ir/kafshjooti" target="_blank" rel="noreferrer">بله</a>
                <a href="https://rubika.ir/dayyerjooti" target="_blank" rel="noreferrer">روبیکا</a>
              </div>
            </div>

            <a href="https://www.instagram.com/dayyer.jooti/" target="_blank" rel="noreferrer" className="jooti-footer-social">
              <FiInstagram />
              <span>اینستاگرام جوتی</span>
            </a>

            <p className="jooti-footer-address">
              <FiMapPin />
              <span>بندر دیر، انتهای خیابان مخابرات، روبروی مسجد امام حسن</span>
            </p>
          </section>
        </div>

        <div className="jooti-footer-bottom">
          <span>© جوتی - تمام حقوق محفوظ است.</span>
          <span>پشتیبانی هر روز از ۹ صبح تا ۱۰ شب</span>
        </div>
      </div>
    
      <div
        className="jooti-developer-credit"
        aria-label="Website developed by Ali"
        lang="en"
        dir="ltr"
      >
        <span>
          Built with
          <span
            className="jooti-developer-credit__heart"
            aria-hidden="true"
          >
            ♥
          </span>
          by
        </span>

        <a
          href="https://alibardestani.ir"
          target="_blank"
          rel="noopener noreferrer"
        >
          Ali
        </a>
      </div>
</footer>
  );
};

export default Footer;
